/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import {
  CdkOverlayOrigin,
  ConnectionPositionPair,
  HorizontalConnectionPos,
  VerticalConnectionPos,
} from '@angular/cdk/overlay';
import {
  Component,
  ElementRef,
  Input,
  OnChanges,
  SimpleChange,
  SimpleChanges,
} from '@angular/core';

@Component({
  standalone: false,
  selector: 'gh-panel',
  templateUrl: 'panel.component.html',
  exportAs: 'ghPanel',
})
export class PanelComponent implements OnChanges {
  @Input() width: number | string;
  @Input() height: number | string;
  @Input() originX: HorizontalConnectionPos;
  @Input() originY: VerticalConnectionPos;
  @Input() overlayX: HorizontalConnectionPos;
  @Input() overlayY: VerticalConnectionPos;

  origin: CdkOverlayOrigin | ElementRef<HTMLElement> | undefined;

  positions: ConnectionPositionPair[];

  isOpen: boolean = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['originX'] || changes['originY'] || changes['overlayX'] || changes['overlayY']) {
      this.positions = [{
        offsetX: void 0,
        offsetY: void 0,
        originX: getCurrentValue(changes['originX'], 'start'),
        originY: getCurrentValue(changes['originY'], 'bottom'),
        overlayX: getCurrentValue(changes['overlayX'], 'start'),
        overlayY: getCurrentValue(changes['overlayY'], 'top'),
      }];
    }
  }

  open(origin: CdkOverlayOrigin | ElementRef<HTMLElement>): void {
    this.origin = origin;
    this.isOpen = true;
  }

  close(): void {
    this.isOpen = false;
  }
}

function getCurrentValue<T>(change: Maybe<SimpleChange>, defaultValue: T): T {
  return change ? change.currentValue : defaultValue;
}
